import { asText, Content, isFilled } from '@prismicio/client';

import { RichText } from '@preventx/prismic-services';
import { Box, Heading, StatItem, Stats } from '@preventx/oxygen';

// Services
import { applicationEnv } from '@/services/env/shared';

type WithStatisticsFeaturesProps = {
  sliceId: string;
  slice: Content.RegionSliceWithStatisticsFeatures;
};

export const WithStatisticsFeatures = ({
  sliceId,
  slice,
}: WithStatisticsFeaturesProps) => {
  const { primary } = slice;
  const { title, caption, features } = primary;

  const { WebsiteUrl } = applicationEnv();

  return (
    <>
      <Box component="div" className="headline align-center">
        <Box component="div" addFlow>
          <Heading component="h2" addHeadlineTitle>
            {asText(title)}
          </Heading>

          {isFilled.richText(caption) && (
            <p className="headline__sub" style={{ maxInlineSize: 'unset' }}>
              {asText(caption)}
            </p>
          )}
        </Box>
      </Box>

      {(features ?? []).length > 0 && (
        <Stats component="ul">
          {features.map((feature, index) => (
            <StatItem
              addFlow
              component="li"
              colour="primary"
              alignment="t-center"
              statistic={asText(feature.title)}
              key={`region-statistics-feature-${sliceId}-${index + 1}`}
            >
              <RichText
                variant="default"
                websiteUrl={WebsiteUrl}
                content={feature.content}
              />
            </StatItem>
          ))}
        </Stats>
      )}
    </>
  );
};
